import { themeLight2, Theme } from '@redislabsdev/redis-ui-styles';

// TODO - remove this when RED-179345 is done
themeLight2.components.sideBar.expanded.width = '20.4rem';

export const themeUi: Theme = themeLight2;
